<template>
  <v-list-group no-action>
    <template #activator>
      <v-list-item-title>{{ listItemTitle }}</v-list-item-title>
    </template>

    <template v-for="pair in pairsOfValues">
      <alteracoes-list-item
        v-if="pair.currentValue && pair.previousValue"
        :content-title="pair.contentTitle"
        :current-value="pair.currentValue"
        :previous-value="pair.previousValue"
      />
    </template>
  </v-list-group>
</template>

<script>
import AlteracoesListItem from './AlteracoesListItem.vue'

export default {
  components: {
    AlteracoesListItem,
  },

  props: {
    listItemTitle: {
      type: String,
      required: true,
    },
    pairsOfValues: {
      type: Array,
      required: true,
    },
  },
}
</script>
